import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/argon-dashboard-react.css"
import "../../assets/css/diagramms/hashTableDiagram.css"
import { stagesNames } from "../translation.js"
import { useLanguage } from "context/LanguageProvider";
import { useEffect } from "react";
import { useDarkMode } from "context/DarkModeProvider";

const HashTableDiagram = ({ table, finalStages, onItemClick }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();
  const { darkMode } = useDarkMode();
  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  const handleItemClick = (bucketIndex, itemIndex) => {
    const uniqueIndex = (() => {
      let count = 0;
      for (let i = 0; i < bucketIndex; i++) {
        count += table[i].length;
      }
      return count + itemIndex;
    })();

    if (onItemClick) {
      onItemClick(uniqueIndex);
      return;
    }

    const stage = finalStages[uniqueIndex];
    if (!stage) {
      console.error("No stage found at index:", uniqueIndex);
      return;
    }

    localStorage.setItem("stageLocation", stage.name);
    localStorage.setItem("selectedStageId", stage.id);

    navigate("/admin/index");
  };

  return (
    <div className="hashtable-container">
      {table.map((bucket, bucketIndex) => (
        <div key={bucketIndex} className="hashtable-row">
          <div className={`hashtable-index ${darkMode ? 'dark-mode' : ''}`}>
            {bucketIndex}
          </div>

          {bucket.length >= 1 && (
            <span className="hashtable-arrow">
              &rarr;
            </span>
          )}

          <div className="hashtable-chain">
            {bucket.map((item, itemIndex) => (
              <React.Fragment key={itemIndex}>
                <div
                  className={`hashtable-item ${darkMode ? 'dark-mode' : ''} ${hoveredItem?.bucket === bucketIndex && hoveredItem?.item === itemIndex ? 'hovered' : ''
                    }`}
                  onMouseEnter={() => setHoveredItem({ bucket: bucketIndex, item: itemIndex })}
                  onMouseLeave={() => setHoveredItem(null)}
                  onClick={() => handleItemClick(bucketIndex, itemIndex)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="hashtable-item-text">
                    {selLanguage ? stagesNames[item.toLowerCase()] : item}
                  </div>
                </div>
                {itemIndex < bucket.length - 1 && (
                  <span className="hashtable-arrow">
                    &rarr;
                  </span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HashTableDiagram;